import LinkButton from '@sats-group/ui-lib/react/link-button';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import BackgroundImage from '../background-image/background-image';
import Breadcrumbs from '../breadcrumbs/breadcrumbs';
import ContentContainer from '../content-container/content-container';
import RichText from '../rich-text/rich-text';
import type { PageHeader as Props } from './page-header.types';

const PageHeader: React.FC<Props> = ({
  actions,
  breadcrumbs,
  blurb,
  containment = ContentContainer.themes.wide,
  image,
  richText,
  slot,
  title,
}) => (
  <div className="page-header">
    <div className="page-header__inner">
      <div className="header__breadcrumbs">
        <Breadcrumbs {...breadcrumbs} theme={Breadcrumbs.themes.fixed} />
      </div>
      <ContentContainer
        className="header__content-container"
        theme={containment}
      >
        <div className="page-header__content">
          <div className="page-header__text">
            <Text
              elementName="h1"
              italic
              size={Text.sizes.headline1}
              theme={Text.themes.headline}
            >
              {title}
            </Text>
            {richText ? (
              <div className="page-header__paragraph">
                <RichText {...richText} />
              </div>
            ) : null}
            {blurb ? (
              <Text className="page-header__paragraph" elementName="p">
                {blurb}
              </Text>
            ) : null}
          </div>
          {slot}
          <div className="page-header__actions">
            {actions.map((entry, index) => (
              <LinkButton
                {...entry}
                key={entry.href}
                size={LinkButton.sizes.large}
                variant={
                  index
                    ? LinkButton.variants.ctaSecondaryWhite
                    : LinkButton.variants.cta
                }
              />
            ))}
          </div>
        </div>
      </ContentContainer>
      <div className="page-header__flair">
        {image ? (
          <BackgroundImage
            {...image}
            focusArea={BackgroundImage.focusAreas.Faces}
          />
        ) : null}
      </div>
    </div>
  </div>
);

export default PageHeader;
